import { render } from "./EventList.vue?vue&type=template&id=7978df24&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=7978df24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\erwin\\Dropbox\\My Projects\\JavaScript\\Vue\\vuemastery\\real-world-vue-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7978df24"]])

export default __exports__